import { escapeAttr, escapeHtml, linkAttrs } from "@emkit/builder-core";
export const LOGO_BAR_DEFAULTS = {
    logos: [
        {
            id: "l1",
            src: "https://placehold.co/160x48/e5e7eb/6b7280?text=ACME",
            alt: "ACME",
        },
        {
            id: "l2",
            src: "https://placehold.co/160x48/e5e7eb/6b7280?text=Globex",
            alt: "Globex",
        },
        {
            id: "l3",
            src: "https://placehold.co/160x48/e5e7eb/6b7280?text=Initech",
            alt: "Initech",
        },
        {
            id: "l4",
            src: "https://placehold.co/160x48/e5e7eb/6b7280?text=Stark",
            alt: "Stark",
        },
        {
            id: "l5",
            src: "https://placehold.co/160x48/e5e7eb/6b7280?text=Wayne",
            alt: "Wayne",
        },
    ],
    title: "Trusted by teams at",
    size: "md",
    grayscale: true,
    background: "transparent",
    textColor: "#6b7280",
    gap: 40,
};
const HEIGHT_BY_SIZE = {
    sm: 24,
    md: 32,
    lg: 44,
};
export const logoBarWidget = {
    type: "logo-bar",
    defaultProps: LOGO_BAR_DEFAULTS,
    renderHtml(props, ctx) {
        const logos = props.logos ?? [];
        if (logos.length === 0) {
            return `<div class="emk-logo-bar" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty logo bar — add logos in the inspector)</div>`;
        }
        const size = props.size ?? "md";
        const height = HEIGHT_BY_SIZE[size];
        const gap = props.gap ?? 40;
        const grayscale = props.grayscale ?? true;
        const bg = props.background ?? "transparent";
        const text = props.textColor ?? "#6b7280";
        const imgStyle = [
            `height:${height}px`,
            "width:auto",
            "max-width:100%",
            "display:block",
            grayscale ? "filter:grayscale(100%);opacity:0.6" : "",
        ]
            .filter(Boolean)
            .join(";");
        const tiles = logos
            .map((lg) => {
            const url = ctx.resolveAssetUrl?.(lg.src) ?? lg.src;
            const img = `<img src="${escapeAttr(url)}" alt="${escapeAttr(lg.alt)}" loading="lazy" decoding="async" style="${imgStyle}">`;
            return lg.href
                ? `<a href="${escapeAttr(lg.href)}"${linkAttrs(lg.href)} class="emk-logo-bar-item" style="display:inline-flex;align-items:center;text-decoration:none">${img}</a>`
                : `<span class="emk-logo-bar-item" style="display:inline-flex;align-items:center">${img}</span>`;
        })
            .join("");
        const title = props.title
            ? `<div class="emk-logo-bar-title" style="text-align:center;font-size:13px;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;color:${text};margin-bottom:24px">${escapeHtml(props.title)}</div>`
            : "";
        const rowStyle = [
            "display:flex",
            "align-items:center",
            "justify-content:center",
            "flex-wrap:wrap",
            `gap:${gap}px`,
        ].join(";");
        return `<div class="emk-logo-bar" style="background:${bg};padding:24px 16px;font-family:inherit">${title}<div style="${rowStyle}">${tiles}</div></div>`;
    },
};
//# sourceMappingURL=logo-bar.js.map